import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { Route as RootRoute } from "../__root"

/**
 * `/onboarding/step-2` — verticals (create + country assignment).
 * Page body lazy-loaded.
 */
export const Route = createRoute({
	getParentRoute: () => RootRoute,
	path: "/onboarding/step-2",
	component: lazyRouteComponent(() => import("./step-2.page")),
})
